// Who we are page

import { useNavigate } from "react-router-dom";
import HeroSection from "../components/Common/HeroSection";
import TimelineSection from "../components/AboutUs/TimeLinesection";
import MissionVision from "../components/Common/MissionVision";
import TeamSection from "../components/AboutUs/TeamSection";
import OurClients from "../components/AboutUs/OurClients";
import FoundersPerspective from "../components/AboutUs/PerspectiveSection";
import LandingHero from "../components/Common/LandingHero";
import data from "../content.json";

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* Hero Section */}
      <div className="relative z-20 overflow-visible">
        <LandingHero data={data.about.hero} />
      </div>

      <div className="h-16 md:h-20 lg:h-24"></div>

      <MissionVision />

      {/* <PerspectiveSection></PerspectiveSection> */}
      <FoundersPerspective
        founderRole="Founder & CEO"
        founderName="PRADIP PARIDA"
        founderImage="/assets/whoWeAre/pradeep.svg"
        founderImageAlt="Pradip Parida"
        quote="A world where every care journey is connected, intelligent, and continuous."
        description="We envision a healthcare ecosystem where systems are deeply integrated, data flows seamlessly, and care is delivered beyond traditional boundaries. By combining digital platforms, real-time insights, and human-centered design, Avexa enables organizations to move from reactive care to proactive, personalized experiences."
        povTitle="Our POV"
        povParagraphs={[
          "At Avexa, we believe healthcare should not be fragmented, reactive, or complex. Our mission is to create a seamless ecosystem where patients, providers, and data work together in real time.",
          "We are focused on transforming care delivery through intelligent systems that simplify operations, enhance decision-making, and improve patient outcomes at scale.",
        ]}
        povImage="/assets/whoWeAre/FoundersPerspective.svg"
        povImageAlt="Avexa office"
      />

      {/* <TimelineSection /> */}

      <TeamSection />

      <OurClients />

      <div className="h-16 md:h-20 lg:h-24 bg-white"></div>
    </div>
  );
};

export default AboutUs;
